import store from '@/store';
import i18n from '@/i18n';

export default class InternalCallStatusEvent {
  constructor(body) {
    console.log('[COLLEAGUES] - Chamada não completada ', body);

    const params = {
      from: body.internalCall.from,
      to: body.internalCall.to,
      status: body.internalCall.status,
    };

    store.dispatch('colleagues/setInternalCallStatus', params);
  }
}
